enum OnboardingRequestOrigin {
  /* eslint-disable no-unused-vars */
  Unknown = 0,
  ManualImport = 1,
  BulkSupplierImport = 2,
  /* eslint-enable no-unused-vars */
}

export default OnboardingRequestOrigin;
